// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/image.js';

import { paths } from '../generated/image';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('image', Original, paths);
